import React, { useEffect } from 'react'
import { LeftSearchMenuPiece } from '../search/LeftSearchMenuPiece'
import { Checkbox } from '@deere/ux.uxframe-react'
import { setStatuses } from '../redux/action/filterAction'
import { useDispatch } from 'react-redux'

export const StatusFilter = ({ setSelected, status = [], selected = [] }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        const setSelectedBaseOnStatus = () => {
            const array = []
            if (status) {
                status.forEach(s => {
                    if (s.checked === true)
                        array.push(s.label)
                })
                setSelected(array)
            }
        }
        setSelectedBaseOnStatus()
    }, [setSelected, status])

    const handleStatusCheckBoxChange = event => {
        const code = event.target.id
        if (!selected.includes(code))
            selected.push(code)
        else {
            const index = selected.indexOf(code);
            if (index > -1) selected.splice(index, 1)
        }
        setSelected([...selected])
        updateStatuses(code)
    }

    const updateStatuses = (code) => {
        const updatedIndex = status.findIndex(ns => ns.label === code)
        status[updatedIndex].checked = !status[updatedIndex].checked
        dispatch(setStatuses(status))
    }

    return (
        <LeftSearchMenuPiece>
            <LeftSearchMenuPiece.Item id="status_filter" title="Status">
                {status.map((s, index) => <Checkbox key={index} label={s.label} id={s.label} onChange={handleStatusCheckBoxChange} checked={s.checked} />)}
            </LeftSearchMenuPiece.Item>
        </LeftSearchMenuPiece>
    )
}